import React from "react";

const ArrowLeft = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
      <path
        data-name="Trazado 1256"
        d="m2.121 2.121 10 10-10 10"
        fill="none"
        stroke="#202d5b"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
      />
    </svg>
  );
};

export default ArrowLeft;
